<template>
	<footer
		class="c-site-footer"
	>
		<div class="mx-auto px-layout-margin w-full max-w-layout-max flex gap-x-[10px] items-center">
      <img src="./../assets/images/footer-logo.jpg" alt="Danske Malermestre" />

      <span class="text-12">
        Bag Malerfagets Behandlings Anvisninger står
        <a
          href="https://www.malermestre.dk/"
          class="underline transition-color duration-300 hover:text-[rgba(0,51,73,0.8)]"
        >
          Danske Malermestre
        </a>
      </span>
		</div>
	</footer>
</template>

<style lang="postcss">
.c-site-footer {
	@apply isolate relative bg-white text-text py-[15px];
}
</style>
